export default __webpack_public_path__ + "static/media/ic_comparator.ec785922.svg";